
export const GET_BOOKINGS_DATA="GET_BOOKINGS_DATA"
export const GET_BOOKINGS_SUCCESS="GET_BOOKINGS_SUCCESS"
export const GET_BOOKINGS_FAIL="GET_BOOKINGS_FAIL"